<template>
    <div class="p_header">
        <div class=" m_header">
            <div class="content" style="max-width: 1080px; text-align: right">
                <div class="select_box">
                    <el-select v-model="searchSelect" placeholder="" class="h_select">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="input_box">
                    <input class="input_ex" type="text" v-model="searchInput" @keypress.enter="boardSearch()"> </input>
                    <button class="btn_search" @click="boardSearch()"></button>
                </div>
                <weblink-list-component></weblink-list-component>
            </div>
        </div>
        <div class="content s_header">
            <div class="h_logo" @click="movePage('/')"></div>
            <div class="h_menu">
                <ul class="header_menu">
                    <li class="lifather" @click="movePage('/intro')" :class="{'active' : checkActive('/intro')}"><a>함께하는아버지들?</a></li>
                    <li class="linews" @click="movePage('/news')" :class="{'active' : checkActive('/news')}"><a>뉴스</a></li>
                    <li class="lidonate" @click="movePage('/donate')" :class="{'active' : checkActive('/donate')}"><a>나눔&배움</a></li>
                    <li class="liarmy" @click="movePage('/amidan')" :class="{'active' : checkActive('/amidan')}"><a>아미단</a></li>
                    <li class="liphoto" @click="movePage('/album')" :class="{'active' : checkActive('/album')}"><a>앨범</a></li>

                </ul>
            </div>
            <button class="h_button" @click="openViolent()">후원하기</button>
        </div>

    </div>
</template>

<script>

    import WeblinkListComponent from "@/components/weblink/WeblinkListComponent";
    import EventBus from "@/utils/event-bus";

    export default {
        name: 'PageHeader',
        components: {WeblinkListComponent},
        mixins: [],
        props: {},
        data() {
            return {
                options: [{
                    value: 'business',
                    label: '주요사업'
                }, {
                    value: 'financial',
                    label: '재무보고'
                }, {
                    value: 'news',
                    label: '뉴스'
                }, {
                    value: 'donate',
                    label: '나눔&배움'
                }, {
                    value: 'album',
                    label: '앨범'
                }],
                searchSelect: 'business',
                searchInput:'',
                activeIndex: '1',
            }
        },
        created() {

        },
        computed: {},
        methods: {
            openViolent(){
                window.open('https://online.mrm.or.kr/RTsnoLd')
            },
            movePage(path) {
                if(this.$route.path === path) {
                    return ;
                }
                this.searchInput = '';
                this.searchSelect = 'business';
                this.$router.push(path);
            },
            boardSearch(){
                this.$router.push(`/search/${this.searchSelect}?su=${this.searchInput}`);
                // this.$router.push(`/search/${this.searchSelect}`);
                EventBus.$emit('setSearchData')
            },
            checkActive(type){
                // return this.$route.path === type
                return this.$route.path.includes(type)
            },

        },
        watch: {
        }
    }

</script>
<style lang="scss">


</style>
